import * as R from 'ramda'

// The /dashboard endpoint only returns an OSS score and its Explori ranks when the
// survey has every question the score is weighted from. When either half is absent
// there is nothing to put on the slide, so callers skip it rather than render blank.
export const hasUsableOssData = (qdata) => Boolean(qdata)
    && Array.isArray(qdata.data)
    && qdata.data.length > 0
    && Boolean(qdata.ossRanks)
    && Object.keys(qdata.ossRanks).length > 0

export const templateHasOssSlide = (data) => R.pathOr([], ['section'], data)
    .some((section) => R.pathOr([], ['slide'], section).some((slide) => slide?.template === 'oss'))
